import React, { FC } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

interface AutoPlaySwipeableViewsProps {
    children: React.ReactNode;
    index: number;
    onChangeIndex: (index: number) => void;
    enableMouseEvents: boolean;
    interval?: number;
}

const AutoPlaySwipeableViews: FC<AutoPlaySwipeableViewsProps> = ({ children, index, onChangeIndex, enableMouseEvents, interval = 3000 }) => {
    const SwipeableViewsWithAutoPlay = autoPlay(SwipeableViews)

    return <SwipeableViewsWithAutoPlay
        index={index}
        onChangeIndex={onChangeIndex}
        enableMouseEvents={enableMouseEvents}
        interval={interval}
    >
        {children}
    </SwipeableViewsWithAutoPlay>
}

export default AutoPlaySwipeableViews;